import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Group, User } from "../users/users-types";
import GroupsTable from "./GroupsTable";

export default function GroupsSection(props: {
  groups: Group[];
  columns: string[];
  users: User[];
  isLoading: boolean;
  isError: any;
}) {
  const { t } = useTranslation();
  console.log("received groups", props.groups);

  return (
    <Box>
      <Stack spacing={2} paddingTop={1} paddingBottom={2}>
        <Typography variant="h5">{t("Groups")}</Typography>
        <GroupsTable
          columns={props.columns}
          users={props.users}
          groups={props.groups}
          isLoading={props.isLoading}
          isError={props.isError}
        />
      </Stack>
    </Box>
  );
}
